import React, { useEffect } from "react";
import ErrorPage from "../ErrorPage";
import { graph } from "../../../images";

const NoChartData = (props) => {
  const { title } = props;

  const intentMessage = title ? `'${title}'.` : "";

  return (
    <ErrorPage
      title={`No chart data available`}
      description={`It appears that there is no data available within the period given`}
      intent={`${intentMessage}`}
      img={graph}
    />
  );
};

export default NoChartData;
